<div class="vh-100 d-flex flex-column bg-gray position-fixed top-0 start-0 w-100">
  <Navbar
    @sidebar-toggle="toggleSidebar"
    class="navbar navbar-expand-lg sticky-top bg-white border-bottom w-100 p-0 m-0"
  ></Navbar>

  
  <Sidebar variant="mobile" offcanvas_id="dashboardSidebarOffcanvas" />
<div class="container-fluid flex-grow-1 overflow-hidden">
    <div class="row h-100">
      <div class="col-auto bg-white h-100 d-none d-lg-block rounded-end mt-2">
        <div class="mt-2">
          <Sidebar ref="sidebar"></Sidebar>
        </div>
      </div>

      <div class="col h-100 overflow-auto">
        <div class="container-fluid py-3 pb-extra px-2 px-sm-3 px-lg-4">
          <section v-if="!is_admin" class="card border shadow-sm rounded bg-light">
            <div class="card-body text-center p-5">
            <button
          class="btn btn-light border rounded-circle d-inline-flex d-lg-none align-items-center justify-content-center p-0 dashboard-workspace-menu me-2 mb-2"
          type="button"
          data-bs-toggle="offcanvas"
          data-bs-target="#dashboardSidebarOffcanvas"
          aria-controls="dashboardSidebarOffcanvas"
          aria-label="Open workspace menu"
        >
          <i class="bx bx-menu-alt-left fs-5"></i>
        </button>

              <i class="bi bi-shield-lock text-muted display-6"></i>
              <h6 class="fw-bold text-dark mt-3 mb-1">Admin Access Required</h6>
              <p class="text-muted small mb-0">Only system admins can manage services.</p>
            </div>
          </section>

          <section v-else class="card border shadow-sm rounded bg-light">
            <div class="card-body p-3 p-lg-4">
              <button
                class="btn btn-light border rounded-circle d-inline-flex d-lg-none align-items-center justify-content-center p-0 dashboard-workspace-menu me-2 mb-2"
                type="button"
                data-bs-toggle="offcanvas"
                data-bs-target="#dashboardSidebarOffcanvas"
                aria-controls="dashboardSidebarOffcanvas"
                aria-label="Open workspace menu"
              >
                <i class="bx bx-menu-alt-left fs-5"></i>
              </button>
              <div class="d-flex flex-column flex-lg-row align-items-lg-center justify-content-between gap-3 mb-3">
                <div>
                  <h6 class="fw-bold text-dark mb-1">Manage Services</h6>
                  <p class="text-muted small mb-0">Review services and track their publishing status.</p>
                </div>
              </div>

              <div class="row g-2 mb-3">
                <div
                  v-for="card in service_dashboard_cards"
                  :key="card.label"
                  class="col-6 col-md-4 col-xl"
                >
                  <button
                    type="button"
                    class="dashboard-summary-card btn border rounded bg-white p-3 h-100 w-100 text-start shadow-sm"
                    :class="{ 'border-primary bg-light': is_service_dashboard_card_active(card) }"
                    @click="handle_service_dashboard_card_click(card)"
                  >
                    <div class="d-flex align-items-start justify-content-between gap-3 h-100">
                      <div class="d-flex flex-column justify-content-between h-100 min-w-0">
                        <div class="text-muted text-xxs fw-bold text-uppercase text-truncate">{{ card.label }}</div>
                        <div class="fw-bold text-dark h4 mb-0 mt-2">{{ card.value }}</div>
                      </div>
                      <span
                        class="portal-dashboard-card-icon rounded-circle d-inline-flex align-items-center justify-content-center bg-light border flex-shrink-0"
                      >
                        <i class="bi" :class="[`text-${card.tone}`, card.icon]"></i>
                      </span>
                    </div>
                  </button>
                </div>
              </div>

              <div v-if="is_loading_services" class="text-center p-5">
                <div class="spinner-border text-primary" role="status"></div>
                <p class="text-muted small mt-2 mb-0">Loading services...</p>
              </div>

              <div v-else-if="filtered_services.length" class="table-responsive">
                <table id="servicesTable" class="table table-striped align-middle bg-white rounded overflow-hidden mb-0 w-100 text-xxs">
                  <thead class="btn-primary text-white">
                    <tr>
                      <th>No.</th>
                      <th>Service</th>
                      <th>Profile</th>
                      <th>Price</th>
                      <th>Status</th>
                      <th class="text-end">Action</th>
                    </tr>
                  </thead>
                  
                  <tbody>
                    <tr v-for="(service, index) in filtered_services" :key="service.id">
                      <td>{{ index + 1 }}</td>
                      <td>
                        <span class="fw-bold text-dark text-xs">{{ service.name }}</span>
                      </td>
                      <td>{{ get_service_profile_name(service) }}</td>
                      <td class="fw-semibold text-dark">R{{ Number(service.price || service.final_price || 0).toLocaleString('en-ZA') }}</td>
                      <td>{{ is_published_service(service) ? 'Published' : 'Unpublished' }}</td>
                      <td class="text-end">
                        <button
                          type="button"
                          class="btn btn-light btn-sm text-primary border"
                          @click="view_service_details(service)"
                        >
                          View
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div v-else class="text-center p-5 bg-white rounded border">
                <i class="bi bi-briefcase text-muted display-6"></i>
                <h6 class="fw-bold text-dark mt-3 mb-1">No Services Found</h6>
                <p class="text-muted small mb-0">There are no services available.</p>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  </div>
</div>
